import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  LawPersonAddress,
} from '@gk/gk-modules';
import { WorkspaceState } from '../../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
  ZamowienieDzialkaDto,
} from '../../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../../shared/shipping-form/shipping-form.model';

export interface SFMPNewRequestDto extends ExtendedApplicantRequestDto {
  Cel: string;
}

export class SFMPNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    proxyDetailsArray: InvestorDetails[],
    public idNumber: number,
    public phoneNumber: number,
    public email: string,
    public address: LawPersonAddress,
    proxyDetailsCheckbox: boolean,
    public attachments: ApiNewDokumentPowiazanyDalDto,
    documentationForm: DocumentationFormType,
    public landParcel: ZamowienieDzialkaDto,
    shippingForm: Shipping,
    public purpose: string,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }
  static fromAppToApi(
    data: SFMPNewRequest,
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): SFMPNewRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        parcels,
        files,
      }),
      Cel: data.purpose,
    };
  }
}

export interface SFMPNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: SFMPNewRequest;
  parcels: EgibObject[];
}
